export default {
  // SNS用メッセージ
  SNS_MESSAGE: 'sns_message',

  APPLY_MESSAGE: '申請が完了しました', // 申請完了のメッセージ
  CANCEL_MESSAGE: '取消が完了しました', // 取消完了のメッセージ
  APPROVAL_MESSAGE: '承認が完了しました', // 承認完了のメッセージ
  REJECTION_MESSAGE: '差戻が完了しました', // 差戻完了のメッセージ

  ERROR_MESSAGE_APPLY: '申請する提出物を選択してください。',

  ERROR_MESSAGE_APPLY_CANCEL: '申請を取り消す提出物を選択してください。',

  ERROR_MESSAGE_APPROVAL: '承認する提出物を選択してください。',

  ERROR_MESSAGE_REJECTION: '差し戻す提出物を選択してください。',

  ERROR_MESSAGE_REJECT_REASON: '差戻しの場合は理由コメントを入力してください。',

  ERROR_MESSAGE_APPLY_ALREADY: '選択した提出物の中に、すでに申請済み（承認待ち）のものが含まれているため申請できません。',

  // 承認者が決まっていない行を申請しようとしたとき。サーバが同じ場面で返す文と同じ。
  ERROR_MESSAGE_APPLY_APPROVER: '承認者を選択してください。',

  // 承認者の候補をまだ読み込んでいる最中に［申請］を押したとき（SA-8、2026-10-09）。
  // 利用者の入力の誤りではないので、「承認者を選択してください。」と欄の枠は出さない。
  MESSAGE_APPLY_APPROVER_LOADING: '承認者の候補を準備しています。恐れ入りますが、しばらく待ってから再度［申請］を押してください。',

  ERROR_MESSAGE_APPLY_CANCEL_ALREADY: '選択した提出物の中に、未申請または差戻のものが含まれているため取り消しできません。',
  
  // 各申請書や精算書への状態メッセージ
  ERROR_UPDATE_MESSAGE_PENDING: '※承認待ちのため更新ができません。' ,
  ERROR_UPDATE_MESSAGE_APPROVAL: '※承認済みのため更新ができません。'
}
